module.exports = __webpack_public_path__ + "media/images/covid/covid-header-233d5525292e9acf4c9bf2bdb5e65095.jpg";